import type {
  AdminListVideoKyCsParams,
  AdminFinalizeVideoKYCInput,
  AdminListAgentKyCsParams,
  AdminFinalizeAgentKYCInput,
} from '../api'
import { api } from '../api'

const adminListVideoKyCs = async (params: AdminListVideoKyCsParams) => {
  return await api.v1.adminListVideoKyCs(params)
}

const adminFinalizeVideoKyc = async (data: AdminFinalizeVideoKYCInput) => {
  return await api.v1.adminFinalizeVideoKyc(data)
}

const adminListAgentKyCs = async (params: AdminListAgentKyCsParams) => {
  return await api.v1.adminListAgentKyCs(params)
}

const adminFinalizeAgentKyc = async (data: AdminFinalizeAgentKYCInput) => {
  return await api.v1.adminFinalizeAgentKyc(data)
}

export default {
  adminListVideoKyCs,
  adminFinalizeVideoKyc,
  adminListAgentKyCs,
  adminFinalizeAgentKyc,
}
